import { useEffect } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Gallery from "@/components/Gallery";
import VideoSection from "@/components/VideoSection";
import Team from "@/components/Team";
import Testimonials from "@/components/Testimonials";
import HoursLocation from "@/components/HoursLocation";
import AppointmentForm from "@/components/AppointmentForm";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-ink text-bone min-h-screen overflow-x-clip">
      <div className="grain-overlay" />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Gallery />
        <VideoSection />
        <Team />
        <Testimonials />
        <HoursLocation />
        <AppointmentForm />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
